import "../../assets/css/login.css";

import { Component } from "react";
import api from "../../lib/api";
import { connect } from "react-redux";
import {
	fetchingUserSuccess,
	updateAppConfigAction,
} from "../../redux/actions";
import { withRouter } from "react-router-dom";
import { isDesktop, isMobile } from "../../lib/helper";
import { getJSONFromUrl, navigateTo, showNotification } from "../../lib/helper";
import { getItem, KEY, setItem } from "../../lib/database";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: this.props.location.state?.email || "",
			password: "",
			two_fa: "",
			is_show_password: false,
			is_show_two_fa: false,
			is_email_send: false,
		};
	}

	componentDidMount() {
		let { r } = getJSONFromUrl();
		if (r) {
			setItem(KEY.REF_USERNAME, r);
		}
	}
	closeLogin = (type) => (e) => {
		e.preventDefault();
		if (type) {
			this.props.updateAppConfigAction({
				[type]: !this.props.appReducer[type],
			});
		}
		navigateTo("/").bind(this)(e);
	};
	onChangeInput = (type) => (e) => {
		this.setState({ [type]: e.target.value });
	};

	onKeyPress = (e) => {
		if (e.code === "Enter") {
			this.onSignIn(e);
		}
	};
	onToggleShowPassword = () => {
		this.setState({ is_show_password: !this.state.is_show_password })
	}
	onSignIn = (e) => {
		e.preventDefault();
		let { enqueueSnackbar } = this.props;
		let { email, password, two_fa } = this.state;
		let isDisableSignButton = !email || email.length === 0 || !password || password.length === 0;
		if (isDisableSignButton) {
			return false;
		}
		api.login({ email, password, two_fa })
			.then(({ data, message, success, code }) => {
				if (!success) {
					if (code === 712) {
						showNotification(enqueueSnackbar, { message, type: 'success' });
						return this.setState({ is_show_two_fa: true });
					}
					showNotification(enqueueSnackbar, { message, type: success ? 'success' : 'danger' });
					return null;
				}
				this.props.fetchingUserSuccess(data);
				navigateTo('trading').bind(this)(e);
				window.location.reload();
			});

	}
	paste = (type) => (e) => {
		e.preventDefault();
		navigator.clipboard.readText().then(text => {
			this.setState({ [type]: text });
		});
	}
	render() {
		let { t } = this.props;
		let { email, password, is_show_password, two_fa, is_show_two_fa, is_email_send } = this.state;
		let isDisableSignButton = !email || email.length === 0 || !password || password.length === 0;
		let { asset_logo } = this.props.appReducer;
		return (
			<div data-v-b0e45e8c="" className="boxContent">
				<div data-v-f99ecb42="" data-v-b0e45e8c="" className="boxFix">
					<div data-v-f99ecb42="" className="boxAuthentication show">
						<div data-v-f99ecb42=""
							className="contentAuthentication d-flex flex-column align-items-center justify-content-lg-start"
							style={{ position: 'fixed', width: isDesktop() ? '500px' : '100%', right: '0', padding: '170px , 150px ,0px , 150px', padding: isMobile() ? '2rem' : '' }}>
							<div data-v-f99ecb42=""
								className="header position-absolute px-3 d-flex align-items-center justify-content-between w-100">
								<a data-v-f99ecb42="" href="/"
									style={{ backgroundImage: 'url(/images/logo-main.png?ver=1182835)', backgroundSize: 'cover' }}
									className="logoLogin mb-0 router-link-active">BoTrade</a>
								<div data-v-f99ecb42="" onClick={this.closeLogin()} className="close-page">
									<span data-v-f99ecb42="" className="pe pe-7s-close" />
								</div>
							</div>
							<div data-v-f99ecb42="" className="formWapper h-100 px-lg-2 w-100" style={{ marginTop: isMobile() ? '5rem' : '' }}>
								<form data-v-f99ecb42="" className={`loginForm d-flex flex-column h-100 colorWhite ${is_show_two_fa ? 'position-relative mt-0' : ''}`}>
									{!is_show_two_fa ? (
										<div>
											<h2
												data-v-f99ecb42=""
												className={`mt-5 color-white font-weight-bold mb-lg-5 mb-3 text-left ${isDesktop() ? 'font-25' : 'font-22'}`}>{t('LoginToYourAccount')}
											</h2>

											<div>
												<div data-v-f99ecb42=""
													className="md-field md-theme-default md-has-placeholder"><label
														data-v-f99ecb42="" htmlFor="md-input-3037ci4xp" className='text-white font-16'>{t('EmailAddress')} *</label>
													<input data-v-f99ecb42="" value={email} onKeyPress={this.onKeyPress} onChange={this.onChangeInput('email')} type="text" aria-autocomplete="false"
														autoComplete="off" id="md-input-3037ci4xp" placeholder={t('InputEmail')} className="md-input background-2F3241" />
													<small className="md-error" />
												</div>
												<div data-v-f99ecb42=""
													className="md-field mb-2 md-theme-default md-has-placeholder md-has-password">
													<label data-v-f99ecb42="" htmlFor="md-input-l9w3oo4ed" className='font-16 text-white'>{t('Password')} *</label>
													<input data-v-f99ecb42="" aria-autocomplete="false"
														type={is_show_password ? 'text' : 'password'}
														autoComplete="off" id="md-input-l9w3oo4ed" value={password} onKeyPress={this.onKeyPress} onChange={this.onChangeInput('password')}
														placeholder={t('InputPassword')} className="md-input background-2F3241 password" /> <small data-v-f99ecb42="" className="md-error" />
													<button type="button"
														onClick={this.onToggleShowPassword}
														className="md-button md-icon-button md-dense md-input-action md-toggle-password md-theme-default"
														tabIndex="-1">
														<div className="md-ripple">
															<div className="md-button-content">
																<i className="md-icon md-icon-font md-icon-image md-theme-default">
																	{is_show_password ?
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width={20}
																			height={21}
																			fill="none"
																		>
																			<path
																				fill="#E5E6ED"
																				d="M17.696 8.948C16.602 7.116 14.146 4.042 10 4.042S3.4 7.116 2.304 8.948a3.019 3.019 0 0 0 0 3.104C3.4 13.884 5.854 16.958 10 16.958s6.602-3.074 7.696-4.906a3.019 3.019 0 0 0 0-3.104Zm-1.072 2.462c-.959 1.605-3.094 4.298-6.624 4.298-3.529 0-5.665-2.692-6.623-4.298a1.775 1.775 0 0 1 0-1.82c.958-1.606 3.094-4.3 6.623-4.3 3.53 0 5.665 2.693 6.624 4.3.335.562.335 1.258 0 1.82ZM10 6.958A3.546 3.546 0 0 0 6.46 10.5 3.546 3.546 0 0 0 10 14.042a3.546 3.546 0 0 0 3.542-3.542A3.546 3.546 0 0 0 10 6.958Zm0 5.834A2.294 2.294 0 0 1 7.71 10.5 2.294 2.294 0 0 1 10 8.208a2.294 2.294 0 0 1 2.292 2.292A2.294 2.294 0 0 1 10 12.792Z"
																			/>
																		</svg>
																		: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M15.8387 10.9576L17.1878 12.9876C17.3787 13.2751 17.3004 13.6634 17.0129 13.8543C16.9062 13.9251 16.787 13.9584 16.6678 13.9584C16.4653 13.9584 16.267 13.8601 16.1462 13.6793L14.8469 11.7252C14.2103 12.1502 13.4603 12.5117 12.5878 12.7626L13.1062 14.8494C13.1904 15.1844 12.9853 15.5235 12.6503 15.6068C12.5994 15.6193 12.5495 15.6251 12.4987 15.6251C12.2187 15.6251 11.9628 15.435 11.8928 15.1509L11.3645 13.0226C10.932 13.0826 10.4837 13.1251 9.99951 13.1251C9.51534 13.1251 9.06706 13.0826 8.63456 13.0226L8.1062 15.1509C8.0362 15.435 7.78032 15.6251 7.50032 15.6251C7.44949 15.6251 7.39959 15.6193 7.34875 15.6068C7.01375 15.5235 6.80949 15.1844 6.89282 14.8494L7.41121 12.7626C6.53955 12.5109 5.78856 12.1493 5.15189 11.7252L3.85286 13.6793C3.73203 13.8601 3.53372 13.9584 3.33122 13.9584C3.21205 13.9584 3.09283 13.9243 2.98616 13.8543C2.69866 13.6634 2.6212 13.2751 2.8112 12.9876L4.16028 10.9576C2.51778 9.45839 1.91607 7.7285 1.90523 7.69767C1.79607 7.37017 1.97365 7.01602 2.30115 6.90685C2.63198 6.79769 2.98198 6.97512 3.09114 7.30012C3.12948 7.41262 3.71372 9.04169 5.31872 10.325C5.32206 10.3267 5.32538 10.3268 5.32788 10.3293C5.33621 10.3351 5.34113 10.3442 5.34863 10.35C6.4103 11.1892 7.90955 11.8743 9.99788 11.8743C12.0862 11.8743 13.5853 11.1884 14.6469 10.35C14.6553 10.3442 14.6596 10.3343 14.6679 10.3293C14.6712 10.3276 14.6745 10.3275 14.677 10.325C16.282 9.04169 16.8661 7.41262 16.9044 7.30012C17.0161 6.97346 17.3704 6.80017 17.6962 6.90767C18.0229 7.01767 18.1987 7.37019 18.0903 7.69685C18.0828 7.72852 17.4812 9.45922 15.8387 10.9576Z" fill="#E5E6ED" />
																		</svg>
																	}
																</i>
															</div>
														</div>
													</button>
												</div>

												<div data-v-f99ecb42="" className="form-group text-right font-16 mb-4 mt-4">
													<a data-v-f99ecb42="" href="#" onClick={navigateTo('forgot-password').bind(this)} className="color-5D6588 ">{t('ForgetPassword')}</a>
												</div>
												<div data-v-f99ecb42="" className="form-group text-center">
													<button data-v-f99ecb42="" type='button' onClick={this.onSignIn} disabled={isDisableSignButton}
														className={' w-100 ' + (isDisableSignButton ? 'btn-secondary btn' : 'btnheader log-in-under d-flex justify-content-center align-items-center text-white font-16')}> {t('Login')}</button>
												</div>
												<div data-v-f99ecb42="" className="d-flex flex-column mt-auto pl-4 position-lg-absolute gap-lg-1rem bottom-1rem">
													<div className='row'>
														<p data-v-f99ecb42="" className="colorGray bottomText font-14 mr-1"> {t('NeedBonaxAccount')}?
														</p>
														<a data-v-f99ecb42="" href="#" onClick={navigateTo('register').bind(this)} className="colorBlue4 font-14"> {t('Register')}</a>
													</div>
													<div className='row'>
														<p>
															<span data-v-f99ecb42="" className="colorGray bottomText font-14 mb-0"> {t('NoConfirmationEmail')} </span>
															<span href='#' className='colorBlue4 font-14'>{t('RequestNewEmail')}</span>
														</p></div>
												</div>
											</div>
										</div>
									) : (
										<div className="position-absolute w-100" style={{ top: '42%', transform: 'translateY(-50%)' }}>
											<h2
												data-v-f99ecb42=""
												className={`mt-5 color-white font-weight-bold mb-lg-5 mb-3 text-left ${isDesktop() ? 'font-25' : 'font-22'}`}>Xác minh bảo mật
											</h2>
											<div data-v-f99ecb42=""
												className="md-field md-theme-default md-has-placeholder c">
												<label data-v-f99ecb42="" htmlFor="md-input-3037ci4xp">{t('GoogleAuthInput')}</label>
												<div className="d-flex cawcw">
													<input data-v-f99ecb42="" value={two_fa} onKeyPress={this.onKeyPress} onChange={this.onChangeInput('two_fa')} type="text" maxLength={6} aria-autocomplete="false"
														autoComplete="off" id="md-input-3037ci4xp" placeholder="Điền mã xác thực trên ứng dụng google auth" className="md-input border-none" />
													<a onClick={this.paste('two_fa')} href=''
														className='colorBlue4' style={{
															height: '50%',
															marginRight: '1rem'
														}}>Paste</a>
												</div>

												<small className="md-error" />
												<button data-v-f99ecb42="" type='button' onClick={this.onSignIn} disabled={two_fa.length < 6}
													className={`w-100 ${two_fa.length < 6 ? 'btn-secondary py-2 rounded-[6px] ' : 'btnheader'} log-in-under mt-3 d-flex justify-content-center align-items-center text-white font-16`}>{t('Send')}</button>
											</div>
										</div>
									)}
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		memberReducer: state.memberReducer,
		appReducer: state.appReducer,
	};
}
const withSnackbar = (Component) => (props) => {
	const { enqueueSnackbar } = useSnackbar();
	return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
	fetchingUserSuccess,
	updateAppConfigAction,
})(withRouter(withTranslation()(withSnackbar(Login))));
